import { Box, BoxProps } from '@chakra-ui/react';

export type NlbRedDotBadgeProps = BoxProps;

export function NlbRedDotBadge(props: NlbRedDotBadgeProps) {
  return (
    <Box
      aria-hidden
      position="absolute"
      top="0"
      right="0"
      boxSize="10px"
      borderRadius="full"
      bg="red.500"
      border="2px solid"
      borderColor="white"
      {...props}
    />
  );
}
